<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  class?: HTMLAttributes['class']
  fullWidth?: boolean
}>()
</script>

<template>
  <div
    :class="
      cn(
        {
          'container px-3 max-lg:w-full min-[1480px]:max-w-360 max-[1480px]:w-11/12 mx-auto':
            !fullWidth
        },
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
